import './grid_section_filters.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';

import without from 'lodash/without';
import includes from 'lodash/includes';

import zfPropTypes from 'zoomforth_codesbane_editor/prop_types.js';

import GridSectionFiltersUi from './grid_section_filters.ui.jsx';

class GridSectionFilters extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedTagIdsByCategoryId: props.appliedTagIdsByCategoryId,
      shouldShowFiltersSelector: false
    };

    autobind(this);
  }

  handleCheckboxChange(categoryId, tagId, isChecked) {
    const { selectedTagIdsByCategoryId } = this.state;

    const currentTags = selectedTagIdsByCategoryId[categoryId] || [];

    if (includes(currentTags, tagId) && !isChecked) {
      this.setState({
        selectedTagIdsByCategoryId: {
          ...selectedTagIdsByCategoryId,
          [categoryId]: without(currentTags, tagId)
        }
      });

    } else if (!includes(currentTags, tagId) && isChecked) {
      this.setState({
        selectedTagIdsByCategoryId: {
          ...selectedTagIdsByCategoryId,
          [categoryId]: [...currentTags, tagId]
        }
      });

    }
  }

  handleRadioChange(categoryId, tagId) {
    const { selectedTagIdsByCategoryId } = this.state;

    this.setState({
      selectedTagIdsByCategoryId: {
        ...selectedTagIdsByCategoryId,
        [categoryId]: [tagId]
      }
    });
  }

  handleDropdownChange(categoryId, tagId) {
    const { selectedTagIdsByCategoryId } = this.state;

    this.setState({
      selectedTagIdsByCategoryId: {
        ...selectedTagIdsByCategoryId,
        [categoryId]: [tagId]
      }
    });
  }

  handleApplyFiltersClick() {
    const { selectedTagIdsByCategoryId } = this.state;
    const { onSetSelectedTagIdsByCategoryId } = this.props;

    onSetSelectedTagIdsByCategoryId(selectedTagIdsByCategoryId);

    this.setState({ shouldShowFiltersSelector: false });
  }

  render() {
    const {
      selectedTagIdsByCategoryId,
      shouldShowFiltersSelector
    } = this.state;

    const {
      categories,
      filterType,
      filterToggleText,
      filtersWidth,
      innerMargin,
      innerWrapperMargin,
      canFiltersBeApplied
    } = this.props;

    return (
      <GridSectionFiltersUi
        categories={categories}
        canFiltersBeApplied={canFiltersBeApplied}
        filterType={filterType}
        filtersWidth={filtersWidth}
        filterToggleText={filterToggleText}
        innerMargin={innerMargin}
        innerWrapperMargin={innerWrapperMargin}
        shouldShowFiltersSelector={shouldShowFiltersSelector}
        selectedTagIdsByCategoryId={selectedTagIdsByCategoryId}
        onCheckboxChange={this.handleCheckboxChange}
        onRadioChange={this.handleRadioChange}
        onDropdownChange={this.handleDropdownChange}
        onApplyFiltersClick={this.handleApplyFiltersClick}
        onShouldShowFilterSelectorChange={(shouldShowFiltersSelector)=> {
          this.setState({ shouldShowFiltersSelector });
        }}
        onResetClick={()=> {
          this.setState({ selectedTagIdsByCategoryId: {} });
        }}
      />
    );
  }

}

GridSectionFilters.defaultProps = {
  canFiltersBeApplied: true
};

GridSectionFilters.propTypes = {
  appliedTagIdsByCategoryId: PropTypes.objectOf(PropTypes.array),
  categories: PropTypes.arrayOf(zfPropTypes.gridTaxonomyCategory).isRequired,
  filterType: zfPropTypes.gridTaxonomyFilterType.isRequired,
  filterToggleText: PropTypes.string.isRequired,
  filtersWidth: PropTypes.number.isRequired,
  innerMargin: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  innerWrapperMargin: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  canFiltersBeApplied: PropTypes.bool.isRequired,
  onSetSelectedTagIdsByCategoryId: PropTypes.func.isRequired 
};

export default GridSectionFilters;
